// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__27_2A","range":"MonthRangeSwitch_range__HTygS","disabled":"MonthRangeSwitch_disabled__2HTgr"};